<template>
	<PageArrows 
		v-bind:linkPrev="`/aml-cll/intro/${which}`"
		v-bind:linkNext="`/patient/${which}/${content[which].nextTab}`"
		v-bind:className="'patient'"
	></PageArrows>
	<ColumnLayout
		v-bind:which="which"
		v-bind:tabType="tabType"
		v-bind:content="content"
		v-on:show-overlay="showOverlay"
	></ColumnLayout>
	<teleport to="body">
		<OverlayModal 
			v-if="content[which].columnOverlay && overlayDisplay" 
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:show-overlay="showOverlay"
			id="overlay-modal"
		>
			<img class="om-single-img" v-bind:width="content[which].columnOverlay" v-bind:src="require(`@/assets/patients/${which}/diagnosis/diagnosis_overlay.png`)" />
		</OverlayModal>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import ColumnLayout from '@/components/ColumnLayout'
import OverlayModal from '@/components/OverlayModal'
export default {
	components: {
		PageArrows,
		ColumnLayout,
		OverlayModal
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'diagnosis',
			overlayDisplay: false,
			content: {
				bishop: {
					classes: 'diagnosis',
					columnA: 625,
					columnAbutton: 237,
					columnButtonAction: 'show-overlay',
					columnOverlay: 957,
					columnB: 304,
					footnote: 368,
					nextTab: 'risk-assessment/'
				},
				carson: {
					columnA: 304,
					columnB: 304,
					columnC: 304,
					columnCbutton: 239,
					columnButtonAction: 'show-overlay',
					columnOverlay: 957,
					nextTab: 'cycle-1/'
				},
				gordon: {
					classes: 'diagnosis',
					columnA: 625,
					columnB: 304,
					columnAbutton: 237,
					columnButtonAction: 'show-overlay',
					columnOverlay: 957,
					footnote: 393,
					nextTab: 'cycle-3/'
				},
				pierce: {
					columnA: 304,
					columnB: 304,
					columnC: 304,
					columnCbutton: 239,
					columnButtonAction: 'show-overlay',
					columnOverlay: 962,
					nextTab: 'pre-initiation/'

				}
			}
		}
	},
	methods: {
		showOverlay(whichActions){
			switch(whichActions[0]){
				case 'show-overlay':
						this.overlayDisplay = whichActions[1]
					break;
			}
		}
	}
}
</script>